import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetMailingUsers } from '../../../../store/mailing/thunk/setGetMailingUsers';
import { setUpdateMailing } from '../../../../store/mailing/thunk/setUpdateMailing';
import TabGeneral from '../../components/TabGeneral';
import TabStatistics from '../../components/TabStatistics';
import { Route } from 'react-router-dom';

const MailingView = () => {
    const router = useRouter();
    const dispatch = useDispatch();


    const [activeTab, setActiveTab] = React.useState('statistics')

    const {id} = router.query;
    const {pathname} = router;

    React.useEffect(() => {
        dispatch(setGetMailing({
            id,
            page: 1,
            pageSize: 1
        }));
        dispatch(setGetMailingUsers({
            id,
            page: 1,
            pageSize: 25,
        }))
    }, []);

    const mailing = useSelector((state) => state.mailing.list?.data)?.[0] || {};

    React.useEffect(() => {
        if (pathname.includes('statistics')) {
            setActiveTab('statistics')
        } else {
            setActiveTab('general')
        }
    }, [pathname]);

    return (
        <div style={{
            padding: '0 20px 20px',
        }}>
            <Title
                label="Рассылка"
                labelBtn={mailing?.is_start === false ? "Запустить рассылку" : undefined}
                button={mailing?.is_start === false ? () => dispatch(setUpdateMailing({id})) : undefined}
            />
            <div style={{display: 'flex', columnGap: 12}}>
                <div onClick={() => {
                    router.history.push(`/mailing/view/${mailing.id}/general`)
                }} style={{
                    padding: 10,
                    background: '#1b2039',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 8,
                    cursor: 'pointer'
                }}>
                    <span style={{color: activeTab === 'general' ? '#FFFFFF' : '#ACACAC'}}>Общая информация</span>
                </div>
                <div onClick={() =>  {
                    router.history.push(`/mailing/view/${mailing.id}/statistics`)
                }} style={{
                    padding: 10,
                    background: '#1b2039',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 8,
                    cursor: 'pointer'
                }}>
                    <span style={{color: activeTab === 'statistics' ? '#FFFFFF' : '#ACACAC'}}>Статистика</span>
                </div>
            </div>
            <Route exact path="/mailing/view/:id" component={() => <TabGeneral mailing={mailing} id={id} />} />
            <Route exact path="/mailing/view/:id/general" component={() => <TabGeneral mailing={mailing} id={id} />} />
            <Route exact path="/mailing/view/:id/statistics" component={() => <TabStatistics />} />
        </div>
    )
}

export default MailingView;